import type { PasswordDTO } from "../../domain/dto/PasswordDTO";
import type { AuthRepository } from "../../domain/repositories/AuthRepository";
import type { EnableTotp } from "../../domain/entities/EnableTotp";
import type { SessionPort } from "../../domain/ports/SessionPort";

export const setupPassword = async (
  repo: AuthRepository,
  sessionPort: SessionPort,
  data: PasswordDTO,
): Promise<EnableTotp> => {
  const accessToken = sessionPort.getAccessToken();
  if (!accessToken) {
    throw new Error("No access token available");
  }

  const result = await repo.setupPassword(data, accessToken);

  // Update session with new password state
  sessionPort.saveSession({
    ...{
      id: "",
      name: "",
      email: result.email,
      phone: "",
      institute_id: "",
      is_active: false,
      access_token: accessToken,
      refresh_token: sessionPort.getRefreshToken() ?? undefined,
      temp_access_token: sessionPort.getTempAccessToken() ?? undefined,
      is_totp_enabled: sessionPort.getIsTotpEnabled() ?? false,
      is_password_set: true,
    } as Parameters<typeof sessionPort.saveSession>[0],
  });

  return result;
};